import { v4 as uuidv4 } from 'uuid';   // as we cannot use crypto's randomUUID in browser


namespace ExtractIdDetails {
  export type Options = {
    /**
     * generate a random ID if the input ID is undefined.
     * @default false
     */
    generateIfMissing?: boolean;
  }
}
export function resolveId (id: string | undefined, options: ExtractIdDetails.Options): string {
  if (id) {
    // ensure the id is on the form "{...}" where ... is the value to be extracted
    if (id.startsWith('{') && id.endsWith('}')) return id.slice(1, -1);
    throw new Error(`Invalid ID format: ${id}`);
  }
  if (options.generateIfMissing) return uuidv4();
  throw new Error('ID is undefined and fallbackToGenerated is false');
}


export function getStartYear (input: string): undefined | number {
  // extract base and offset year
  const _baseYear   = input.match(/^BaseYear=(\d{4})$/m)    ?.at(1);
  const _offsetYear = input.match(/^OffsetYear=(\d{1,2})$/m)?.at(1);
  if (_baseYear == null || _offsetYear == null) return;

  // the year of the start date
  const startYear = parseInt(_baseYear, 10) + parseInt(_offsetYear, 10);
  if (isNaN(startYear)) return;

  return startYear;
}